import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexXAxis,
  ApexDataLabels,
  ApexYAxis,
  ApexTitleSubtitle,
  ApexGrid,
  ApexTheme,
  ApexTooltip,
  ApexPlotOptions
} from 'ng-apexcharts';
import { SegmentationModel } from '../../model/score-card.model';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  title: ApexTitleSubtitle;
  fill: ApexFill;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  theme: ApexTheme,
  tooltip: ApexTooltip,
  plotOptions: ApexPlotOptions
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});


@Component({
  selector: 'app-segment-matrix-chart',
  templateUrl: './segment-matrix-chart.component.html',
  styleUrls: ['./segment-matrix-chart.component.scss']
})
export class SegmentMatrixChartComponent implements OnInit {

  // @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  width: number;
  height: number;
  constructor(
    private dialogRef: MatDialogRef<SegmentMatrixChartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SegmentationModel[],
  ) {
    this.width = window.innerHeight;
    this.height = parseInt(this.dialogRef._containerInstance._config.height.slice(0, 3), 10);
    this.chartOptions = {
      series: [
        {
          name: 'Bubble1',
          data: this.generateData1(data)
        },
      ],
      chart: {
        height: this.height - (this.height * 18 / 100),
        width: this.height - (this.height * 28 / 100),
        type: 'bubble',
        toolbar: {
          tools: {
            download: false,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
            customIcons: []
          },
        },
        zoom: {
          enabled: false
        },
        events: {
          mounted: () => {
            this.resizeChart();
          },
          animationEnd: () => {
            this.reRenderChart();
          },
          updated: () => {
            this.resizeChart();
            this.reRenderChart();
          }
        },
        redrawOnParentResize: true
      },
      theme: {
        mode: 'light',
        palette: 'palette9',
        monochrome: {
          enabled: false,
          color: '#A5978B',
          shadeTo: 'light',
          shadeIntensity: 0.65
        },
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        // colors: ['#a9b5c1'],
        opacity: 0.8
      },
      xaxis: {
        type: 'numeric',
        tickAmount: 3,
        min: 0,
        max: 85,
        labels: {
          formatter: (val) => {
            // tslint:disable-next-line:radix
            return parseInt(val).toFixed(0);
          }
        }
      },
      yaxis: {
        decimalsInFloat: 0,
        tickAmount: 3,
        min: 0,
        max: 115
      },
      grid: {
        show: true,
        borderColor: '#ced8e1',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        },
        row: {
          colors: undefined,
          opacity: 0.5
        },
        column: {
          colors: undefined,
          opacity: 0.5
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
      },
      tooltip: {
        custom: ({series, seriesIndex, dataPointIndex, w}) => {
          const dataPoint = this.data[dataPointIndex];
          return `<div class="d-flex flex-column p-2 font-weight-bold" style="width: auto">
            <span>${dataPoint.gsl ? `GSL Number: ` + dataPoint.supplierName : `Parent Name: ` + dataPoint.parent}</span></ br>
            <span>${dataPoint.commodity ? `Commodity: : ` + dataPoint.commodity : ''}</span></ br>
            <span>Performance Score:  ${dataPoint.totalPerformanceScore}</span></ br>
            <span>Behaviors Score:  ${dataPoint.totalRelationShipScore}</span></ br>
            <span>Period Spend:  ${this.formatTotalSpend(dataPoint.periodSpend)}</span></ br>
          </div>`;
        }
      },
      plotOptions: {
        bubble: {
          minBubbleRadius: 7,
          maxBubbleRadius: 24,
        }
      }
    };
  }

  ngOnInit() {
  }

  public generateData1(data) {
    let series = [];
    series = data.map((item: SegmentationModel) => {
      const array = [item.totalRelationShipScore, item.totalPerformanceScore, item.periodSpend];
      return array;
    });
    return series;

  }

  private reRenderChart() {

    const canvas = document.getElementsByClassName('apexcharts-canvas')[0];
    canvas.setAttribute('style', 'margin: 0 auto; width:' + this.width / 2 + 'px; transform: translateX(-20px);');
    const svg = document.querySelector('.apexcharts-graphical').querySelector('.apexcharts-grid')
      .querySelector('.apexcharts-gridlines-horizontal');

    if (!svg.querySelector('image')) {
      // const width = Math.max(svg.getBoundingClientRect().width, svg.getBoundingClientRect().height);
      // const height = Math.max(svg.getBoundingClientRect().height, svg.getBoundingClientRect().width);
      // image.setAttribute('style', 'background-image: url('../../../../assets/images/empty-image.png');background-repeat: no-repeat;');

      const container = svg.parentElement;
      const rect = container.getBoundingClientRect();
      const width = Math.max(rect.width, rect.height);
      const height = Math.max(rect.height, rect.width);
      
      const svgimg = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      svgimg.setAttribute('style', 'background-repeat: no-repeat;background-size:cover;background-position: center;width:'
      + width + 'px;height:' + height + 'px;');
      svgimg.setAttributeNS('http://www.w3.org/2000/svg', 'id', 'background');
      svgimg.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '../../../../assets/images/ge-segmentation-matrix_1.svg');
      svg.appendChild(svgimg);
    }

  }

  private resizeChart() {
    const width = this.height - (this.height * 25 / 100) + 20 + 'px';
    const canvas = document.getElementsByClassName('apexcharts-canvas')[0];
    canvas.setAttribute('style', 'margin: 0 auto; width: ' + width + ';');
  }

  private fintIndexComma(str: string) {
    return str.search(',');
  }

  private formatTotalSpend(value) {
    const formatNumber = formatter.format(value);
    if (formatNumber.split(',').length > 2) {
      return (formatNumber.slice(0, this.fintIndexComma(formatNumber) + 3) + 'M').replace('$', '');
    }
    if (formatNumber.split(',').length > 1) {
      return (formatNumber.slice(0, this.fintIndexComma(formatNumber)) + 'K').replace('$', '');
    }
    return value;
  }

}
